import $ from 'jquery';

const defaults = {
  block_title: undefined,
  block_title_plural: undefined,
  applyTo: [],
};

function RelatedProfilesAlt(element, options, context) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.$body = this.getBody(context);
  this.init();
}

RelatedProfilesAlt.prototype = {
  init() {
    this.settings.applyTo.forEach((value) => {
      const $exists = this.$body.is(`.wt${value}`);
      const moreThanOne = this.$element.find('.views-row').length;
      const plural = (this.settings.block_title_plural) ? this.settings.block_title_plural : `${this.settings.block_title}s`;
      const newTitle = (moreThanOne > 1) ? plural : this.settings.block_title;
      if ($exists) {
        this.$element
          .find('.block-title-text')
          .text(newTitle)
          .addClass('ready');
      }
    });
  },

  getBody(context) {
    return $(document.body, context);
  },
};

export default RelatedProfilesAlt;
